const state = {
  faviconCache: {},     
  pendingFaviconCache: {}
};
const mutations = {
  SET_FAVICON(state, { domain, data }) {
    state.faviconCache = {
      ...state.faviconCache,
      [domain]: data,
    };
  },
  SET_PENDING_FAVICON(state, { domain, pending }) {
    state.pendingFaviconCache = {
      ...state.pendingFaviconCache,
      [domain]: pending,
    };
  },
};
const actions = {
  setFavicon({ commit }, { domain, data }) {
    commit('SET_FAVICON', { domain, data });
  },
  setPendingFavicon({ commit }, { domain, pending}) {
    commit('SET_PENDING_FAVICON', { domain, pending });
  }
};
const getters = {
  getFavicon: (state) => (domain) => {
    return state.faviconCache[domain] || null;
  },
  getPendingFavicon: (state) => (domain) => {
    return state.pendingFaviconCache[domain] || null;
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};